import { useNavigate } from "react-router-dom";

function Hero() {
  const navigate = useNavigate();

  return (
    <section className="hero">
      <div className="hero-grid"></div>

      {/* Tagline Badge */}
      <div className="hero-badge">
        🚀 AI-Powered Emerging Technology Learning Platform
      </div>

      {/* Main Heading */}
<h1 className="hero-title">
  AI-Powered Emerging Technology Learning Platform
  <br />
  <span className="hero-highlight">
    for Future-Ready Professionals
  </span>
</h1>

    
      
      
      {/* Subheading */}
      <p className="hero-subtext">
        Master AI, Full Stack Development, Data Science, Cloud Computing,
        Cybersecurity, and other emerging technologies through live training,
        real-world projects, expert mentorship, and career-focused learning.
      </p>

      {/* Highlights */}
      <div className="hero-highlights">
        <span>🚀 Live Training</span>
        <span>💼 Industry Projects</span>
        <span>🎯 Expert Mentors</span>
        <span>🏆 Job Ready</span>
      </div>

      {/* CTA */}
      <div className="hero-buttons">
        <button
          className="primary"
          onClick={() => navigate("/pricing")}
        >
          Start Learning
        </button>

        <button
          className="secondary"
          onClick={() => navigate("/about")}
        >
          Explore Programs
        </button>
      </div>
    </section>
  );
}

export default Hero;